var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    fill: "currentColor",
    viewBox: "0 0 16 15",
    stroke: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M 3.857 0 L 1 2.857 L 1 13.143 L 4.429 13.143 L 4.429 16 L 7.286 13.143 L 9.57 13.143 L 14.714 8 L 14.714 0 L 3.857 0 Z M 13.571 7.429 L 11.286 9.714 L 9 9.714 L 7 11.714 L 7 9.714 L 4.429 9.714 L 4.429 1.143 L 13.571 1.143 L 13.571 7.429 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 255, 255)",
      strokeWidth: "0.1px"
    },
    d: "M 13.584 1.13 L 4.413 1.143 L 4.427 9.714 L 6.986 9.723 L 6.993 11.712 L 9.004 9.711 L 11.305 9.705 L 13.573 7.427 L 13.6 1.631 L 13.603 1.127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11.886 3.1 L 10.743 3.1 L 10.743 6.527 L 11.886 6.527 L 11.886 3.1 Z M 8.743 3.1 L 7.6 3.1 L 7.6 6.527 L 8.743 6.527 L 8.743 3.1 Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M11.857 3.143h-1.143V6.57h1.143V3.143zm-3.143 0H7.571V6.57h1.143V3.143z",
    style: {
      fill: "rgb(0, 0, 0)",
      strokeWidth: "0.1px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.5dc44dbf84cdedd71166d113bafa5a40.svg";
export { ForwardRef as ReactComponent };